import { render, staticRenderFns } from "./faqItem.vue?vue&type=template&id=2ef5d4d7&scoped=true"
import script from "./faqItem.vue?vue&type=script&lang=js"
export * from "./faqItem.vue?vue&type=script&lang=js"
import style0 from "./faqItem.vue?vue&type=style&index=0&id=2ef5d4d7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ef5d4d7",
  null
  
)

export default component.exports